const ugc_carousel = document.querySelector(".gf-ugc-content-carousel");
const hero_slider = document.querySelector(".splide-ai");

if (ugc_carousel) {
  new Splide(ugc_carousel, {
    type: "loop",
    perPage: 4,
    gap: 32,
    breakpoints: {
      800: { perPage: 3 },
      600: { perPage: 2 },
      480: { perPage: 1 },
    },
  }).mount();
}

if (hero_slider) {
  new Splide(hero_slider).mount();
}
